import React, { useState } from 'react';
import { useNavigate } from 'react-router';
import { useAlert } from 'contexts/AlertContext';
import { BlockedUsersList } from 'components/settings';
import './BlockedUsers.css';

interface BlockedUser {
    id: number;
    name: string;
    blockedDate: string;
}

export const BlockedUsers: React.FC = () => {
    const navigate = useNavigate();
    const { showConfirm } = useAlert();
    const [blockedUsers, setBlockedUsers] = useState<BlockedUser[]>([
        { id: 1, name: '김철수', blockedDate: '2024.05.01' },
        { id: 2, name: '이영희', blockedDate: '2024.06.15' },
        { id: 3, name: '박지영', blockedDate: '2024.07.10' }
    ]);
    const [searchQuery, setSearchQuery] = useState('');

    const handleUnblock = async (user: BlockedUser) => {
        const confirmed = await showConfirm({
            message: `${user.name}님의 차단을 해제하시겠습니까?`
        });
        if (confirmed) {
            setBlockedUsers(blockedUsers.filter(u => u.id !== user.id));
        }
    };

    const filteredUsers = blockedUsers.filter(user =>
        user.name.toLowerCase().includes(searchQuery.toLowerCase())
    );

    return (
        <div className="blocked-users-wrapper">
            <div className="blocked-users-header">
                <button className="back-button" onClick={() => navigate('/settings')}>
                    ←
                </button>
                <h1 className="blocked-users-title">채팅 차단 관리</h1>
            </div>

            <div className="blocked-users-content">
                {/* 검색바 */}
                <div className="search-section">
                    <input
                        type="text"
                        placeholder="🔍 이름 또는 닉네임 검색"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="search-input"
                    />
                </div>

                {/* 차단된 사용자 정보 */}
                <div className="info-box">
                    <p className="info-text">
                        ⚠️ 차단된 사용자는 회원님에게 메시지를 보낼 수 없으며, 모임 초대 목록에도 표시되지 않습니다.
                    </p>
                </div>

                <BlockedUsersList
                    users={filteredUsers}
                    totalCount={blockedUsers.length}
                    searchQuery={searchQuery}
                    onUnblock={handleUnblock}
                />
            </div>
        </div>
    );
};
